import { t } from "i18next";
const processAppointmentStatus = () => {
    const appointmentStatus_rootSource = [
        {
            id: "to_confirm",
            text: t("appointments_statuses:to_confirm"),
            filtered: true,
        },
        {
            id: "confirmed",
            text: t("appointments_statuses:confirmed"),
            filtered: true,
        },
        {
            id: "present",
            text: t("appointments_statuses:present"),
            filtered: true,
        },
        {
            id: "present_with_study_partner",
            text: t("appointments_statuses:present_with_study_partner"),
            filtered: true,
        },
        {
            id: "no_show",
            text: t("appointments_statuses:no_show"),
            filtered: true,
        },
        {
            id: "left_message",
            text: t("appointments_statuses:left_message"),
            filtered: true,
        },
        {
            id: "cancelled",
            text: t("appointments_statuses:cancelled"),
            filtered: true,
        },
        {
            id: "rescheduled",
            text: t("appointments_statuses:rescheduled"),
            filtered: true,
        },
        {
            id: "to_reschedule",
            text: t("appointments_statuses:to_reschedule"),
            filtered: true,
        },
        {
            id: "tentative",
            text: t("appointments_statuses:tentative"),
            filtered: true,
        },
        {
            id: "patient_unreachable",
            text: t("appointments_statuses:patient_unreachable"),
            filtered: true,
        },
        {
            id: "completed",
            text: t("appointments_statuses:completed"),
            filtered: true,
        },
        {
            id: "deleted",
            text: t("appointments_statuses:deleted"),
            filtered: false,
        },
    ];
    let appointmentStatus;
    if (localStorage.appointment_status) {
        appointmentStatus = JSON.parse(localStorage.appointment_status);
    } else {
        appointmentStatus = appointmentStatus_rootSource;
    }
    return appointmentStatus;
};
export default processAppointmentStatus;
